@if(incomeTaxEntity$ | async) {
  <form [formGroup]="aangeverFg">
    <div class="row col-auto">
      <snelstart-ui-text-form-control class="custom-input-150"
                                      formControlName="voorletters"
                                      id="voorletters"
                                      label="Voorletter(s)"
      >
      </snelstart-ui-text-form-control>
      <snelstart-ui-text-form-control class="custom-input-125"
                                      formControlName="tussenvoegsels"
                                      id="tussenvoegsels"
                                      label="Tussenvoegsel"
      >
      </snelstart-ui-text-form-control>
    </div>
    <div class="col-auto">
      <snelstart-ui-text-form-control [required]=true
                                      class="custom-input-250"
                                      formControlName="achternaam"
                                      id="achternaam"
                                      label="Achternaam"
      >
      </snelstart-ui-text-form-control>
    </div>
    <div class="col-auto">
      <snelstart-ui-date-form-control [required]=true
                                      class="custom-input-250"
                                      formControlName="geboortedatum"
                                      id="geboortedatumAangever"
                                      label="Geboortedatum"
                                      placeholder="dd-mm-jjjj"

      >
      </snelstart-ui-date-form-control>
    </div>
    <div class="col-auto">
      <snelstart-ui-bsn-form-control [required]=true
                                     class="custom-input-250"
                                     formControlName="bsn"
                                     id="bsn"
                                     label="Burgerservicenummer"
      >
      </snelstart-ui-bsn-form-control>
    </div>
    @if ((incomeTaxEntity$ | async)?.aangifte?.biljetSoort === "F") {
      <div class="col-auto">
        <snelstart-ui-date-form-control class="custom-input-250"
                                        formControlName="overlijdensdatum"
                                        id="overlijdensdatum"
                                        label="Overlijdensdatum"
                                        placeholder="dd-mm-jjjj"

        >
        </snelstart-ui-date-form-control>
      </div>
    }
    <div class="col-auto row g-0">
      <snelstart-ui-select-form-control [options]="optiesBurgerlijkeStaat"
                                        [required]=true
                                        class="custom-input-250 col-auto"
                                        formControlName="burgerlijkeStaat"
                                        id="burgerlijkeStaat"
                                        label="Burgerlijke staat in {{(incomeTaxEntity$ | async)?.aangifte?.aangifteJaar}}"
      >
      </snelstart-ui-select-form-control>
      <span class="ps-3 pt-4 row col-auto"
            snelstartUiTooltip="Met de keuze 'Gewijzigd/deels samenwonend' wordt de situatie bedoeld dat de aangever een deel van het jaar {{(incomeTaxEntity$ | async)?.aangifte?.aangifteJaar}} een echtgenoot of huisgenoot heeft."> &#x24D8;</span>
    </div>

    @if (aangeverFg.controls.burgerlijkeStaat.value === AangeverBurgerlijkeStaat.SAMENWONEND) {
      <snelstart-ui-select-form-control [options]="optiesSamenwonend"
                                        [required]=true
                                        class="custom-input-250"
                                        formControlName="samenwoonSituatie"
                                        label="Situatie in heel {{(incomeTaxEntity$ | async)?.aangifte?.aangifteJaar}}"

      >
      </snelstart-ui-select-form-control>
    }

    @if ((incomeTaxEntity$ | async)?.aangifte?.biljetSoort === "C") {
      <div class="col-auto">
        <snelstart-ui-select-form-control [options]="optionsLandcodesMetNld"
                                          class="custom-input-250"
                                          formControlName="landCodeNationaliteit"
                                          id="nationaliteit"
                                          label="Nationaliteit"
        >
        </snelstart-ui-select-form-control>
      </div>
    }
  </form>

  @if ((incomeTaxEntity$ | async)?.aangifte?.biljetSoort === "C") {
    <form [formGroup]="woonlandFg">
      <div class="col-auto">
        <snelstart-ui-select-form-control [options]="optionsLandcodesZonderNld"
                                          class="custom-input-250"
                                          formControlName="landCodeWoonland"
                                          id="landCodeWoonland"
                                          label="Woonland heel {{(incomeTaxEntity$ | async)?.aangifte?.aangifteJaar!}}"
        >
        </snelstart-ui-select-form-control>
      </div>
      @if (woonlandFg.get('woonlandVoldoetVoorKwalificatie')?.getRawValue()) {
        <div class="col-auto row g-0">
          <snelstart-ui-select-form-control [disabledControl]="false"
                                            [options]="optionsJaNee"
                                            class="custom-input-250"
                                            formControlName="belastingplichtigeVoldoetAanVoorwaardenKwalificatie"
                                            id="belastingplichtigeVoldoetAanVoorwaardenKwalificatie"
                                            label="Kwalificerend belastingplichtige"
          >
          </snelstart-ui-select-form-control>
          <span class="ps-3 pt-4 row col-auto"
                snelstartUiTooltip="Kies 'ja' indien 90% of meer van het totale inkomen in {{(incomeTaxEntity$ | async)?.aangifte?.aangifteJaar}} in Nederland belast is."> &#x24D8;</span>
        </div>
      }
    </form>
  }

  @if (aangeverFg.controls.geboortedatum === undefined) {
    <snelstart-ui-alert type="warning">
      Let op! Er is nog geen geboortedatum ingevuld. Deze is wel belangrijk voor een juiste berekening van de
      verschuldigde belasting.
    </snelstart-ui-alert>
  }
}
